import { render, staticRenderFns } from "./global.vue?vue&type=template&id=6ee31e04&scoped=true&"
import script from "./global.vue?vue&type=script&lang=js&"
export * from "./global.vue?vue&type=script&lang=js&"
import style0 from "./global.vue?vue&type=style&index=0&id=6ee31e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee31e04",
  null
  
)

export default component.exports